/**
 * api/backlog.js — Product Backlog + Ciclos (Fase 5 · Bloco 4a).
 * GET  /projects/{id}/backlog            → hierarquia + ciclos
 * POST /projects/{id}/backlog/generate   → gera via tech-lead (Claude)
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';

export function useBacklog(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['backlog', projectId],
    queryFn:  () => api.get(`/projects/${projectId}/backlog`),
    enabled:  Boolean(projectId),
  });
}

export function useGenerateBacklog(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationKey: ['ai'],
    meta: { aiLabel: 'A IA está gerando o Product Backlog…', aiSublabel: 'Derivando épicos, histórias e critérios de aceite a partir do escopo aprovado.' },
    mutationFn: () => api.post(`/projects/${projectId}/backlog/generate`, {}),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['backlog', projectId] }),
  });
}

export function useReplanCycles(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    // Determinístico (sem IA) — a tela mostra spinner local "Replanejando…".
    mutationFn: (count) => api.post(`/projects/${projectId}/cycles/replan`, { count }),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['backlog', projectId] }),
  });
}

/**
 * useCommitBacklog — confirma o backlog/ciclos e indexa o resumo na memória.
 * Acionado pelo "Próximo" dos steps backlog/cycles (beforeNext), garantindo que
 * o escopo esteja no contexto/RAG antes do Gate de Escopo e dos ciclos.
 */
export function useCommitBacklog(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post(`/projects/${projectId}/backlog/commit`, {}),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['backlog', projectId] }),
  });
}
